/**
 * Is there audible speech in this chunk of customer audio?
 *
 * gpt-live streams near-silent PCM frames before and between utterances, so
 * "an audio frame arrived" is not "the customer spoke". The threshold matches
 * the server's KB_LIVE_CUSTOMER_VOICE_LEVEL default: a PCM16 sample above it
 * is speech, not codec noise.
 */
export const CUSTOMER_VOICE_LEVEL = 100;

/**
 * The rep's microphone: matches the server's KB_LIVE_REP_VOICE_LEVEL default.
 * Higher than the customer level because a live mic carries room noise.
 */
export const REP_VOICE_LEVEL = 500;

export function hasAudibleVoice(pcm: ArrayBuffer, level: number = CUSTOMER_VOICE_LEVEL): boolean {
  if (!pcm || pcm.byteLength < 2) return false;
  const samples = new Int16Array(pcm, 0, Math.floor(pcm.byteLength / 2));
  for (let index = 0; index < samples.length; index += 1) {
    if (Math.abs(samples[index]) > level) return true;
  }
  return false;
}
